export default __webpack_public_path__ + "static/media/custom_dev_img.baf4b4fb.svg";